/**
 * WASSER Admin - Palette Configuration
 * Поддержка light/dark mode
 */
import {
  backgroundColors,
  brandColors,
  statusColors,
  textColors,
} from '@shared/theme/colors.js';

// Dark mode цвета
const darkBackgroundColors = {
  default: '#0F1115',
  paper: '#161A22',
  hover: 'rgba(255, 255, 255, 0.04)',
  selected: 'rgba(255, 255, 255, 0.08)',
};

const darkTextColors = {
  primary: '#F3F4F6',
  secondary: '#9CA3AF',
  disabled: 'rgba(255, 255, 255, 0.38)',
};

/**
 * Генерирует палитру для заданного режима
 * @param {'light' | 'dark'} mode - Режим темы
 */
export const getPalette = (mode = 'light') => {
  const isDark = mode === 'dark';

  return {
    mode,
    primary: brandColors.primary,
    secondary: brandColors.secondary,

    success: statusColors.success,
    warning: statusColors.warning,
    error: statusColors.error,
    info: statusColors.info,

    background: isDark
      ? darkBackgroundColors
      : {
          default: backgroundColors.default,
          paper: backgroundColors.paper,
        },

    text: isDark
      ? darkTextColors
      : {
          primary: textColors.primary,
          secondary: textColors.secondary,
        },

    divider: isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)',

    action: {
      active: isDark ? 'rgba(255, 255, 255, 0.56)' : 'rgba(0, 0, 0, 0.54)',
      hover: isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
      selected: isDark ? 'rgba(255, 255, 255, 0.16)' : 'rgba(0, 0, 0, 0.08)',
      disabled: isDark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.26)',
      disabledBackground: isDark
        ? 'rgba(255, 255, 255, 0.12)'
        : 'rgba(0, 0, 0, 0.12)',
    },
  };
};
